const GLOBAL_ACTION_TYPES = {
    SET_GLOBAL_COLOR:'global/SET_GLOBAL_COLOR',
    SET_MAIN_PRODUCT:'global/SET_MAIN_PRODUCT',
    SET_POSITION_TWO:'global/SET_POSITION_TWO',
    SET_POSITION_THREE:'global/SET_POSITION_THREE',
    SET_POSITION_FOUR:'global/SET_POSITION_FOUR',
    SET_DRAWER_STATUS:'global/SET_DRAWER_STATUS'
}
export default GLOBAL_ACTION_TYPES